import React from 'react';

import { Box, useToast } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { HomePage } from 'components/features/home-page';
import { ModalAuth } from 'components/modal-auth';
import useAuth from 'hooks/auth/use-auth';
import { useRumPageView } from 'hooks/rum/use-rum-page-view';
import { LoyaltyCtaBar } from 'pages/loyalty/loyalty-cta-bar';
import useAuthFlow from 'state/auth/hooks/use-auth-flow';
import { ModalAuthScreen } from 'state/auth/types';
import { useScrollViewFullHeight } from 'state/scroll/hooks';
import { isMobile } from 'utils/environment';

const Home = () => {
  useScrollViewFullHeight();
  const { formatMessage } = useIntl();
  const { setModalAuthState } = useAuth();
  const toast = useToast();

  const { triggerSignInAccessibility } = useAuthFlow();
  const signInAccessibilityMsg = triggerSignInAccessibility
    ? formatMessage({ id: 'visuallyHiddenSignInSuccess' })
    : '';

  useRumPageView('home', 'Home');

  return (
    <Box
      flex={1}
      testID="homepage"
      accessibilityLabel={signInAccessibilityMsg}
      accessibilityRole="alert"
    >
      {isMobile() && <LoyaltyCtaBar />}
      <HomePage />
      <ModalAuth
        shouldDisplaySignInSuccessMessage
        shouldWaitLoginForVendor
        onSignInSuccess={() => {
          setModalAuthState({ screen: ModalAuthScreen.CLOSED });
          toast.show({
            text: formatMessage({ id: 'signInSuccess' }),
            variant: 'positive',
          });
        }}
      />
    </Box>
  );
};

export default Home;
